import React, { useState, useEffect } from 'react'
import { IoCloseOutline } from "react-icons/io5";

function ListPopup(props) {
  const [controls, setControls] = useState(false)

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        props.cancelPopup();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [])
  

  return (

    <div className="modal-wrapper modal-scroll">
      <div className="modal-popup modal-lg">
        <div className="modal-innerpopup ">
          <div className="modal-headdiv d-flex justify-content-between">
            <span className="closeBtn text-center"><IoCloseOutline size={32} onClick={() => props.cancelPopup()} /></span>
          </div>
          <div className="modal-body-wrapper">
            <div className='row'>
              <div className='col-md-12'>
                {props.selectedData.file_type_id == "2" ?
                  <video muted className="object-fit-contain w-100 video-image"
                    controls={controls}
                    controlsList="nodownload"
                    onContextMenu={(event)=>event.preventDefault()}
                    onPlay={() => {
                      if (!props.isAuthenticated) {
                        window.location.href = "/login";
                      }
                    }}
                    onTimeUpdate={(e) => {
                      const video = e.target;
                      if (props.selectedData.end_time_totalseconds && video.currentTime >= props.selectedData.end_time_totalseconds) {
                        video.pause();
                      }
                    }}
                    onLoadedMetadata={(e) => {
                      const video = e.target;
                      video.currentTime = props.selectedData.start_time_totalseconds || 0;
                    }}
                    onMouseEnter={() => setControls(true)}
                    onMouseLeave={() => setControls(false)}>
                    <source src={props.selectedData.url} type="video/mp4" />
                    Your browser does not support HTML5 video.
                  </video>
                  :
                  <div className='list-all-popup-height'>
                    <img src={props.selectedData.url} className="card-img-top" alt="..." 
                        onContextMenu={(event)=>event.preventDefault()}/>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ListPopup